import classNames from 'classnames'
import styles from './Header.module.scss'

interface Props {
  title: string
  description: string
}

export const Header = ({ title, description }: Props) => {
  return (
    <div className={styles.container}>
      <h3 className={classNames('text-truncate', styles.title)}>{title}</h3>
      <p className={styles.description}>{description}</p>
    </div>
  )
}
